/** basic.patrolTask */
export default {
    task_naemSear: "Поиск по имени инспектора",
    task_ssear: "Поиск",
    task_chargePerson: "Ответственный",
    task_desc: "Описание задачи",
    task_type: "Тип задачи",
    task_state: "Статус задачи",
    task_notStarted: "Не начато",
    task_underWay: "В процессе",
    task_UnCompleted: "Не завершено",
    task_completed: "Завершено",
    task_name: "Имя инспектора",
    task_phone: "Телефон инспектора",
    task_createrTime: "Время начала",
    task_deleteTips: "Удалить эту задачу инспекции?",
    task_deleteBtn: "Удалить",
    task_dialogTitle: "Новая задача инспекции",
    task_drawerTitle: "Детали задачи инспекции",

    add_name: "Инспектор",
    add_roleName: "Название роли",
    add_phone: "Мобильный телефон",
    add_UserNamePla: "Введите имя пользователя для поиска",
    add_starTime: "Время начала",
    add_endTime: "Время окончания",
    add_taskLabel: "Связанные объекты задачи",
    add_selectTime: "Выберите дату и время",
    add_descPla: "Введите описание задачи",
    add_submitFormBtn: "Создать",
    add_rulesTaskType: "Выберите тип задачи",
    add_rulesPatrolMan: "Выберите инспектора",
    add_rulesOpenTime: "Выберите время начала и окончания",
    add_rulesEntity: "Выберите организацию",
    add_ruelsDesc: "Введите описание задачи",
    add_addLose: "Не удалось добавить!",
    add_taskID: "ID задачи",
    add_rulesSite: "Выберите объект",

    basic_hiddenTRoubleType: "Тип нарушения",
    basic_patrolName: "Имя инспектора",
    basic_patrolPhone: "Телефон инспектора",
    basic_patrolNameSex: "Пол инспектора",
    basic_alterTime: "Время изменения",
    basic_taskDesc: "Описание задачи",
    basic_cardTitle: "Записи инспекции",
    basic_createUser: "Создатель",
    basic_patrolState: "Статус проверки",

    basic_dialogTitle: "Состояние проверки",
    basic_dangerLevel: "Уровень опасности",
    basic_noDanger: "Нет опасности",
    basic_oneDanger: "Опасность уровня 1",
    basic_twoDanger: "Опасность уровня 2",
    basic_threeDanger: "Опасность уровня 3",
    basic_handleState: "Статус обработки",
    basic_processed: "Обработано",
    basic_pending: "Ожидает обработки",
    basic_abnormalTypeName: "Название типа аномалии",
    basic_checkImg: "Фото проверки",
    basic_AfterAbarbeitungImg: "Фото после устранения",
    basic_noAbarbeitungImg: "Нет фото устранения",
    basic_uploadingServer: "Подтвердить загрузку на сервер",
    basic_abarbeitungImg: "Фото устранения",
    basic_messageOneImg: "Сначала выберите изображение для загрузки!",
    basic_messageOnlyUpImg: "За один раз можно загрузить только одно изображение!",
}

